import { CandidateEditProfileEmpty, WorkType } from 'candidate/types';
import { action, autorun, computed, makeObservable, observable } from 'mobx';
import { MultiSelectViewModel } from 'shared/components';
import { v4 as uuidv4 } from 'uuid';
export type WorkTypeWithId = WorkType & { id: string };
export class WorkTypes extends MultiSelectViewModel<WorkTypeWithId> {
  query: string = '';
  workTypes: WorkTypeWithId[] = [];

  constructor() {
    super(undefined, {});
    makeObservable(this, {
      workTypes: observable,
      results: computed,
      set: action,
    });
  }

  set(workTypes: CandidateEditProfileEmpty['work_types']): void {
    this.workTypes = [
      ...Object.entries(workTypes),
    ].map(([k, v]) => ({
      label: v,
      value: k,
      id: uuidv4(),
    }));
    console.log(this.workTypes, 'WE');
  }

  get results(): WorkTypeWithId[] {
    return this.workTypes.filter((wType) =>
      wType.label.toLowerCase().includes(this.search)
    );
  }

  clear(): void {
    this.query = '';
  }
}
